const mandates = [
  {
    id: 'mandate-nvg-rakshak',
    name: 'NVG Rakshak',
    subtitle: '1, 2 & 3 BHK Ultra Luxury Apartments',
    location: 'KIADB Aerospace Park, Bagalur, North Bangalore 562149',
    totalPlots: 0,
    plotSizes: '1, 2 & 3 BHK | 1045 - 1550 sq.ft (Super Built-up)',
    approvals: ['RERA Approved', 'KIADB Aerospace Park'],
    statusPills: ['Ultra Luxury', 'Ready to Build'],
    startingPrice: null,
    commission: '5%',
    heroImageUrl:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
    galleryImageUrls: [
      'https://images.unsplash.com/photo-1502005097973-6a7082348e28?auto=format&fit=crop&w=1200&q=80',
    ],
    about:
      'NVG Rakshak is a landmark of luxury living at KIADB Aerospace Park, Bagalur. Designed with modern architecture and timeless elegance, it offers a premium lifestyle with thoughtfully planned interiors and community-focused spaces.',
    highlights: [
      'RERA No: PRM/KA/RERA/1251/472/PR/091024/007138',
      'Vastu compliant unit plans',
      'UPVC windows and balcony doors',
      'Premium wiring by Havells/Anchor/Polycab/Finolex',
    ],
    amenities: [
      'Bangalore International Airport access',
      'Proximity to Reva University, DPS, NPS',
      'Nearby Aster Hospital & Columbia Asia',
      'Close to Decathlon, Byg Brewski, Hebbal Flyover',
    ],
    documents: {
      brochureUrl: '/mandates/nvg-rakshak.pdf',
    },
  },
  {
    id: 'mandate-2',
    name: 'Crestview Enclave',
    subtitle: 'Ready to Build Villa Plots',
    location: 'Yelahanka, Bengaluru',
    totalPlots: 96,
    plotSizes: '1200 - 2400 sq. ft',
    approvals: ['RERA', 'DTCP Approved'],
    statusPills: ['Ready to build'],
    startingPrice: 'From ?42L',
    commission: '5%',
    heroImageUrl:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
    galleryImageUrls: [
      'https://images.unsplash.com/photo-1502005097973-6a7082348e28?auto=format&fit=crop&w=1200&q=80',
    ],
    about:
      'Crestview Enclave is a gated villa plot community surrounded by green buffers, tech corridors, and lifestyle conveniences.',
    highlights: ['Gated community', 'Wide internal roads', 'EV charging ready'],
    amenities: ['Clubhouse', 'Swimming pool', 'Yoga deck', 'CCTV monitoring'],
    documents: {
      brochureUrl: 'https://example.com/crestview-brochure.pdf',
      priceSheetUrl: 'https://example.com/crestview-price.pdf',
    },
  },
  {
    id: 'mandate-3',
    name: 'Azure Vista',
    subtitle: 'High-growth Investment Plots',
    location: 'Maheshwaram, Hyderabad',
    totalPlots: 220,
    plotSizes: '135 - 300 sq. yds',
    approvals: ['DTCP Approved'],
    statusPills: ['Early bird'],
    startingPrice: 'From ?14.9L',
    commission: '5%',
    heroImageUrl:
      'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80',
    galleryImageUrls: [
      'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?auto=format&fit=crop&w=1200&q=80',
    ],
    about:
      'Azure Vista is positioned for rapid growth with excellent airport access and planned infrastructure upgrades.',
    highlights: ['Near ORR access', 'Planned metro connectivity', 'Dedicated commercial zone'],
    amenities: ['Open gym', 'Community lawns', 'Pet park'],
    documents: {
      brochureUrl: 'https://example.com/azure-brochure.pdf',
    },
  },
  {
    id: 'mandate-4',
    name: 'Evergreen Heights',
    subtitle: 'Premium Family Apartments',
    location: 'Whitefield, Bengaluru',
    totalPlots: 140,
    plotSizes: '2 & 3 BHK | 980 - 1600 sq.ft',
    approvals: ['RERA Approved', 'BDA Approved'],
    statusPills: ['New Launch'],
    startingPrice: 'From ₹62L',
    commission: '5%',
    heroImageUrl: 'https://images.unsplash.com/photo-1502005097973-6a7082348e28?auto=format&fit=crop&w=1200&q=80',
    galleryImageUrls: [
      'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?auto=format&fit=crop&w=1200&q=80',
    ],
    about:
      'Evergreen Heights offers spacious family apartments with easy access to tech parks, schools, and shopping hubs.',
    highlights: ['Clubhouse & gym', 'Landscaped gardens', '24/7 security'],
    amenities: ['Swimming pool', 'Kids play area', 'Community hall'],
    documents: {
      brochureUrl: 'https://example.com/evergreen-brochure.pdf',
    },
  },
];

export default mandates;
